module.exports = {
  "simple-flow-item-wrapper": {
    "flexDirection": "row"
  },
  "flex-row": {
    "flexDirection": "row"
  },
  "full-rest": {
    "flex": 1
  },
  "root": {
    "paddingTop": "28",
    "paddingBottom": "24",
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "content": {
    "paddingTop": "9",
    "paddingBottom": "42",
    "paddingLeft": "70",
    "paddingRight": "70"
  },
  "last-one-content": {
    "paddingBottom": 0
  },
  "title": {
    "paddingLeft": "70",
    "paddingRight": "70"
  },
  "line": {
    "position": "absolute",
    "top": 0,
    "bottom": 0,
    "left": "38",
    "width": "2",
    "backgroundColor": "#dddddd"
  },
  "first-one-title-line": {
    "top": "20"
  },
  "last-one-title-line": {
    "bottom": "20"
  },
  "last-one-content-line": {
    "width": 0
  },
  "point": {
    "position": "absolute",
    "top": "6",
    "left": "33",
    "width": "12",
    "height": "12",
    "backgroundColor": "#dddddd",
    "borderRadius": "100",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "highlightInner": {
    "width": "12",
    "height": "12",
    "borderRadius": "12"
  },
  "highlight-point": {
    "top": "4",
    "left": "25",
    "width": "28",
    "height": "28"
  },
  "text-title": {
    "fontSize": "28",
    "color": "#8e969b"
  },
  "left-text-date": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "24",
    "color": "rgba(255,255,255,0.4)"
  },
  "text-highlight-title": {
    "color": "#00a4f2"
  },
  "text-desc": {
    "fontSize": "24",
    "color": "#8e969b",
    "marginBottom": "12",
    "lineHeight": "32",
    "lines": 3,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "text-date": {
    "fontSize": "24",
    "color": "#8e969b"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-bc5f15f4!./~/weex-vue-loader/lib/selector.js?type=styles&index=2!./packages/dof-simple-flow/index.vue
// module id = 539
// module chunks = 0 1